export default __webpack_public_path__ + "static/media/small.7b73dcf2.jpg";